export function profileFonts(
  siteFontFamilies,
  buttonFontFamilies,
  fontWeight,
  titleFontFamilies,
  titleInherit,
  titleFontWeight,
) {
  const fontFamilies = [];
  if (siteFontFamilies.is_google_font) {
    fontFamilies.push(
      `${siteFontFamilies.family.replace(/\s/g, '+')}${
        siteFontFamilies.variants.includes('700') ? ':wght@400;700' : ''
      }`,
    );
  }
  if (buttonFontFamilies.is_google_font) {
    fontFamilies.push(
      `${buttonFontFamilies.family.replace(/\s/g, '+')}:wght@${fontWeight}`,
    );
  }
  if (!titleInherit && titleFontFamilies && titleFontFamilies.is_google_font) {
    fontFamilies.push(
      `${titleFontFamilies.family.replace(/\s/g, '+')}:wght@${titleFontWeight}`,
    );
  }

  return Array.from(new Set(fontFamilies));
}
